import { Link } from '@tanstack/react-router'
import type { QuoteResponseDto } from '@trellis/api'
import { RowActions } from '@trellis/roots/data'
import type { RowAction } from '@trellis/roots/data'
import { Archive, ArchiveRestore, Check, Edit, Eye, Trash2 } from 'lucide-react'

export function QuoteRowActionsMenu({
  quote,
  onDeleteClick,
  onPreviewClick,
  onArchiveClick,
  onUnarchiveClick,
  onMarkSentClick,
}: {
  quote: QuoteResponseDto
  onDeleteClick: (quote: QuoteResponseDto) => void
  onPreviewClick: (quote: QuoteResponseDto) => void
  onArchiveClick: (quote: QuoteResponseDto) => void
  onUnarchiveClick: (quote: QuoteResponseDto) => void
  onMarkSentClick: (quote: QuoteResponseDto) => void
}) {
  const isDraft = quote.status === 'DRAFT'
  const isArchived = !!quote.archivedAt

  const actions: RowAction[] = [
    {
      label: 'View',
      icon: <Eye className="mr-2 h-4 w-4" />,
      href: `/quotes/${quote.id}`,
    },
    ...(isDraft
      ? [
          {
            label: 'Edit',
            icon: <Edit className="mr-2 h-4 w-4" />,
            href: `/quotes/${quote.id}/edit`,
          } satisfies RowAction,
        ]
      : []),
    ...(isDraft
      ? [
          {
            label: 'Mark as sent',
            icon: <Check className="mr-2 h-4 w-4" />,
            onClick: () => onMarkSentClick(quote),
            separator: true,
          } satisfies RowAction,
        ]
      : []),
    ...(isArchived
      ? [
          {
            label: 'Unarchive',
            icon: <ArchiveRestore className="mr-2 h-4 w-4" />,
            onClick: () => onUnarchiveClick(quote),
            separator: true,
          } satisfies RowAction,
        ]
      : [
          {
            label: 'Archive',
            icon: <Archive className="mr-2 h-4 w-4" />,
            onClick: () => onArchiveClick(quote),
            separator: true,
          } satisfies RowAction,
        ]),
    ...(isDraft
      ? [
          {
            label: 'Delete',
            icon: <Trash2 className="mr-2 h-4 w-4" />,
            onClick: () => onDeleteClick(quote),
            destructive: true,
            separator: true,
          } satisfies RowAction,
        ]
      : []),
  ]

  return (
    <RowActions
      onViewClick={() => onPreviewClick(quote)}
      triggerLabel={`Open actions menu for ${quote.displayNumber}`}
      actions={actions}
      linkComponent={Link}
    />
  )
}
